import { type SxProps, type Theme } from '@mui/material';

import { MAX_WIDTH } from '@/config/theme/theme.ts';
import { themeColors } from '@/config/theme/themeColors.ts';

export const SCROLLBAR_GUTTER = '3px';
const SCROLLBAR_GUTTER_BACKGROUND = 'rgba(21, 190, 240, 0.5)';

export const getAppWrapperStyles = (isLoginView: boolean): SxProps<Theme> => ({
  backgroundColor: isLoginView ? 'transparent' : themeColors.bg,
  display: 'flex',
  height: '100vh',
  margin: '0 auto',
  maxWidth: MAX_WIDTH,
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  zIndex: 1,
  ...(isLoginView
    ? {}
    : {
        [`@media (min-width: calc(${MAX_WIDTH} + 1px))`]: {
          boxShadow: `0 0 0 1px ${themeColors.silverTwo}`,
        },
      }),
});

export const getAppContentStyles = (marginLeft: number, isLoginView = false): SxProps<Theme> => ({
  backgroundColor: isLoginView ? 'transparent' : themeColors.bg,
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  height: '100vh',
  marginLeft: `${marginLeft}px`,
  minWidth: 0,
  overflowX: 'hidden',
  overflowY: 'auto',
  position: 'relative',
  // Keeps the top bar from shifting when a page gains or loses a scrollbar.
  scrollbarGutter: 'stable',
  transition: 'margin-left 0.2s ease-out',
  ...(isLoginView
    ? {}
    : {
        '&::after': {
          backgroundColor: SCROLLBAR_GUTTER_BACKGROUND,
          bottom: 0,
          content: '""',
          pointerEvents: 'none',
          position: 'fixed',
          right: `max(0px, calc((100vw - ${MAX_WIDTH}) / 2))`,
          top: 0,
          width: SCROLLBAR_GUTTER,
          zIndex: 90,
        },
      }),
});
